import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../Elements/HtmlContainerElement";
import { BetManager } from "../../Managers/BetManager";
import { RouletteBetType } from "../../CustomComponents/RouletteBetType";
import { Communication } from "neo-games";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlNumberHistory extends HtmlContainerElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    public static ElementId: string = "numberHistory";

    private static readonly BaseNumberClassName: string = "valueBox";

    private _count: number;

    private _lastWinningNumbersElements: Array<HTMLElement>;

    private _lastWinningNumbers: Array<number>;

    private _redNumbers: Array<number>;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();

        this._lastWinningNumbersElements = [];
        this._redNumbers = BetManager.getBetNumbersByBetType(RouletteBetType.RedOrBlack, 0);
    }

    //******************************************************************************************************************
    //  HANDLE HISTORY NUMBERS
    //******************************************************************************************************************

    public initialize(statistics: Communication.Game.IRouletteStatistics): void {
        //create first empty element used for animation
        this.createNumberElement();

        if (statistics == null) {
            return;
        }

        const lastWinningNumbers = statistics.lastWinningNumbers;

        if (lastWinningNumbers != null) {
            this._lastWinningNumbers = lastWinningNumbers;

            //create elements
            for (let i = 0; i < lastWinningNumbers.length; i++) {
                let numberElement = this.createNumberElement();
                this.setupNumberElement(numberElement, lastWinningNumbers[i]);

                if (i == lastWinningNumbers.length - 1) {
                    numberElement.classList.add("lastValue");
                }
            }

            if (this._lastWinningNumbers != null && this._lastWinningNumbers.length > 0) {
                this.instance.classList.remove("_hidden");
            }
        }
    }

    public update(statistics: Communication.Game.IRouletteStatistics): void {
        if (statistics == null) {
            return;
        }

        const historyNumbers = statistics.lastWinningNumbers;

        if (historyNumbers != null) {
            let move = this.moveNumbers(historyNumbers);
            let newNumber = historyNumbers[historyNumbers.length - 1];
            let numberElement: HTMLElement;

            for (let i = 0; i < this._lastWinningNumbersElements.length; i++) {
                this._lastWinningNumbersElements[i].classList.remove("lastValue");
            }

            if (move) {
                for (let i = 0; i < this._lastWinningNumbersElements.length; i++) {
                    let winNumber = i == 0 ? this._lastWinningNumbers[0] : historyNumbers[i - 1];
                    numberElement = this._lastWinningNumbersElements[i];
                    this.setupNumberElement(numberElement, winNumber);

                    numberElement.offsetWidth; //force animations
                    if (i == 0) {
                        numberElement.classList.add("hideAnim");
                    } else if (i == this._lastWinningNumbersElements.length - 1) {
                        numberElement.classList.add("showAnim", "lastValue");
                    } else {
                        numberElement.classList.add("moveAnim");
                    }
                }
            } else {
                numberElement = this.createNumberElement();
                this.setupNumberElement(numberElement, newNumber);
                numberElement.classList.add("showNewAnim", "lastValue");
            }

            this._lastWinningNumbers = historyNumbers;

            if (this._lastWinningNumbers.length > 0) {
                this.instance.classList.remove("_hidden");
            }
        }
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    private createNumberElement(): HTMLElement {
        let numberElement = document.createElement("div");
        let numberValue = document.createElement("div");
        numberValue.className = "value";

        numberElement.appendChild(numberValue);
        this._lastWinningNumbersElements.push(numberElement);

        const numberContainer = this.instance.getElementsByClassName("numbersContainer")[0];
        if (numberContainer != null) {
            numberContainer.appendChild(numberElement);
        }

        return numberElement;
    }

    private setupNumberElement(element: HTMLElement, number: number): void {
        let numberValue = element.getElementsByClassName("value")[0];
        if (numberValue != null) {
            numberValue.className = "value";
            numberValue.textContent = number.toString();

            if (number == 0) {
                numberValue.classList.add("zeroNumber");
            } else if (this._redNumbers.indexOf(number) > -1) {
                numberValue.classList.add("redNumber");
            } else {
                numberValue.classList.add("blackNumber");
            }
        }

        element.className = HtmlNumberHistory.BaseNumberClassName;
    }

    private moveNumbers(historyNumbers: Array<number>): boolean {
        return historyNumbers.length > 1 && historyNumbers.length == this._lastWinningNumbers.length;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlNumberHistory.ts
 **/